// components/SubmitButton.jsx
import React from "react";

const SubmitButton = ({ isSubmitting, disabled = false }) => {
  return (
    <button
      className="form__submit-btn btn btn-primary mb-3 cursor-pointer"
      type="submit"
      disabled={isSubmitting || disabled}
    >
      {isSubmitting ? (
        <>
          <span
            className="form__spinner spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Submitting...
        </>
      ) : (
        "Submit Survey"
      )}
    </button>
  );
};

export default SubmitButton;
